document.addEventListener('DOMContentLoaded', function () {

  // ---- Mystery box hero interaction ----
  var mbox = document.getElementById('mbox');
  if (mbox) {
    mbox.addEventListener('click', function () {
      mbox.classList.remove('shake');
      void mbox.offsetWidth;
      mbox.classList.add('shake');
    });
    mbox.addEventListener('mousemove', function (e) {
      var r = mbox.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      mbox.style.transform = 'rotateY(' + (x * 18) + 'deg) rotateX(' + (-y * 18) + 'deg)';
    });
    mbox.addEventListener('mouseleave', function () {
      mbox.style.transform = '';
    });
  }

  // ---- FAQ accordion ----
  document.querySelectorAll('.faq-item button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // ---- Mobile nav toggle ----
  var burger = document.getElementById('navBurger');
  var mobileNav = document.getElementById('mobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('show');
    });
  }

  // ---- Product variant picker ----
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var pid = form.getAttribute('data-product-id');
    var dataEl = document.getElementById('product-variants-' + pid);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var selects = form.querySelectorAll('.variant-select');
    var hiddenInput = form.querySelector('.variant-id-input');
    var priceEl = document.getElementById('product-price-' + pid);
    var submitBtn = form.querySelector('.product-submit');
    var submitDefaultText = submitBtn ? submitBtn.textContent : '';

    function updateVariant() {
      var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.filter(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return opts[i] === val; });
      })[0];

      if (!match) return;

      hiddenInput.value = match.id;

      if (priceEl && typeof match.price === 'number') {
        priceEl.textContent = '$' + (match.price / 100).toFixed(2);
      }

      if (submitBtn) {
        if (match.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitDefaultText;
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold out';
        }
      }
    }

    selects.forEach(function (s) {
      s.addEventListener('change', updateVariant);
    });
  });

});
